import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sipMiningApi = createAsyncThunk(
  "sipMining",
  // async (params) => {
  //   const response = await axiosInstance.get("/report/sip", { params });
  //   return response.data;
  // }

  async ({ status, name = "", startDate = "", endDate = "" }) => {
    const params = {};
    if (status) {
      params.status = status;
    }
    if (name) {
      params.name = name;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/sip", {
      params,
    });
    if (response) {
      return response.data;
    }
  }
);

const sipMiningSlice = createSlice({
  name: "sipMining",
  initialState: {
    sipMining: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sipMiningApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sipMiningApi.fulfilled, (state, action) => {
        state.sipMining = action.payload;
        state.loading = false;
      })
      .addCase(sipMiningApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sipMiningSlice.reducer;


// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axiosInstance";

// export const sipMiningApi = createAsyncThunk(
//   "sipMining",
//   async ({ startDate = null, endDate = null }) => {
//     const params = {};
//     if (startDate) params.startDate = startDate;
//     if (endDate) params.endDate = endDate;
//     const response = await axiosInstance.get("/report/sip?status=LINK_EXPIRED", { params });
//     return response.data;
//   }
// );

// const sipMiningSlice = createSlice({
//   name: "sipMining",
//   initialState: {
//     sipMining: [],
//     errors: [],
//     loading: false,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(sipMiningApi.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(sipMiningApi.fulfilled, (state, action) => {
//         state.sipMining = action.payload;
//         state.loading = false;
//       })
//       .addCase(sipMiningApi.rejected, (state, action) => {
//         state.errors.push(action.error.message);
//         state.loading = false;
//       });
//   },
// });

// export default sipMiningSlice.reducer;
